import React from 'react';
import Box from '../Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import Icon from '../Icon/Icon'; // Import the Icon component
import { TIcon } from '../../types/TStyleVariables';

export type TLinkBase = {
  href?: string;
  onClick?: (e?: any) => void;
  kind?: 'block' | 'isolated' | 'paragraph' | 'standalone';
  target?: string;
  className?: string;
  rel?: string;
  iconLeft?: TIcon;
  iconRight?: TIcon;
  role?: string;
  elementRef?: React.Ref<HTMLElement>;
} & React.HTMLAttributes<any>;

const LinkBase = ({
  kind,
  href,
  onClick,
  iconLeft,
  iconRight,
  children,
  role = 'link',
  elementRef,
  ...rest
}: TLinkBase) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind || 'isolated',
  });

  const htmlTagName = href ? 'a' : 'button';

  return (
    <Box
      {...rest}
      ref={elementRef}
      name="Link"
      as={htmlTagName}
      type={htmlTagName === 'button' ? 'button' : undefined}
      onClick={onClick}
      href={href}
      {...conditionalProps}
      role={role}
    >
      {iconLeft && <Icon name={iconLeft} color="text-link-default" />}
      {children}
      {iconRight && <Icon name={iconRight} color="text-link-default" />}
    </Box>
  );
};

export default LinkBase;
